var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"patient_result bg-white"},[(_vm.$route.params.type === 'success')?_c('base-result',{attrs:{"text":"绑定成功"}},[_c('van-button',{attrs:{"type":"primary","block":""},on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v("去首页")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }